import { graphql } from '../graphql/generated';

export const DOCTOR_THEME_QUERY = graphql(`
  query DoctorTheme($doctorId: ID!) {
    doctor(id: $doctorId) {
      id
      theme {
        id
        name
        colorBgHeader
        colorBgTrigger
        colorPrimary
        controlItemBgActive
        controlItemBgActiveHover
        logoData
      }
    }
  }
`);
